import {FunctionComponent, useCallback} from 'react';
import PlaceholderIcon from '@/assets/images/icon-placeholder-design-system.svg?react';
import Button from '@/components/button';
import {BUTTON_ICON_POSITION, BUTTON_THEME} from '@/constants/button';
import {logger} from '@/initializers/logger';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';

const Buttons: FunctionComponent = () => {
  const mockOnClick = useCallback(() => {
    logger.log();
  }, []);

  return (
    <ul className="flex flex-col gap-8">
      <li>
        <h3 className="mb-2 font-semibold text-charcoal">Bouton avec texte et icône</h3>
        <div className="flex flex-row gap-2">
          <Button
            label="Terminer"
            trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
            icon={<PlaceholderIcon className="size-4" />}
            onClick={mockOnClick}
          />

          <Button
            iconPosition={BUTTON_ICON_POSITION.RIGHT}
            label="Terminer"
            trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
            icon={<PlaceholderIcon className="size-4" />}
            onClick={mockOnClick}
          />
        </div>
      </li>

      <li>
        <h3 className="mb-2 font-semibold text-charcoal">Bouton sans texte avec icône</h3>
        <Button
          icon={<PlaceholderIcon className="size-4" />}
          trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
          onClick={mockOnClick}
        />
      </li>

      <li>
        <h3 className="mb-2 font-semibold text-charcoal">Bouton sans texte avec icône – Désactivé</h3>
        <Button
          disabled={true}
          icon={<PlaceholderIcon className="size-4 fill-grey-650" />}
          trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
          onClick={mockOnClick}
        />
      </li>

      <li>
        <h3 className="mb-2 font-semibold text-charcoal">
          Bouton avec texte et icône – Thèmes secondaire et tertiaire
        </h3>

        <div className="flex flex-row gap-2">
          <Button
            label="Terminer"
            className="group"
            theme={BUTTON_THEME.SECONDARY}
            trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
            icon={<PlaceholderIcon className="size-4" />}
            onClick={mockOnClick}
          />

          <Button
            label="Terminer"
            theme={BUTTON_THEME.TERTIARY}
            trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
            icon={<PlaceholderIcon className="size-4" />}
            onClick={mockOnClick}
          />
        </div>
      </li>
    </ul>
  );
};

export default Buttons;
